const toUserSite = (user) => {
    let site = ""
    switch (user) {
      case "حارس": {
        site = "/transport";
        break;
      }
      case "admin": {
        site = "/admin";
        break;
      }
      default: {
        site = "/wpuphones";
        break;
      }
    }
    return site
  }
export default toUserSite